import { Box, Paper, Stack, Typography } from '@mui/material';
import IncSwitchBase from 'components/forms/fields/inc-switch-field/inc-switch-base/inc-switch-base.component';
import { useLocationHoursContext } from 'components/location-hours/location-hours.context';
import { getGroupedBackgroundEvents } from '../temporary-hours.utils';
import { useMemo } from 'react';
import { blue, green } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import StandardHoursListItem from './standard-hours-list-item/standard-hours-list-item.component';

const StandardHoursList = () => {
  const { t } = useTranslation();
  const {
    standardHours: { isShowingNormalHours, setIsShowingNormalHours },
    temporaryHours: { backgroundEvents },
  } = useLocationHoursContext();

  const onChange = (_e, checked) => {
    setIsShowingNormalHours(checked);
  };

  const groupedBackgroundEvents = useMemo(
    () => getGroupedBackgroundEvents(backgroundEvents),
    [backgroundEvents],
  );

  const isBgEventsEmpty = array => array.length === 0;

  return (
    <Paper
      elevation={3}
      sx={{ display: { xs: 'none', md: 'block' }, p: 2, mt: 2 }}
    >
      <Typography variant="h5">
        {t('LocationHours.temporaryHours.standardHours.title')}
      </Typography>
      <IncSwitchBase
        label={t(
          'LocationHours.temporaryHours.standardHours.showHoursSwitch.label',
        )}
        value={isShowingNormalHours}
        onChange={onChange}
        FormControlProps={{ sx: { mt: 1 } }}
        data-testid="ShowHours"
        disabled={isBgEventsEmpty(groupedBackgroundEvents)}
      />

      <Stack
        display="flex"
        direction="column"
        gap={2}
        maxWidth={320}
        data-testid="StandardHours.List"
      >
        {isBgEventsEmpty(groupedBackgroundEvents) ? (
          <Typography
            variant="body2"
            color="text.secondary"
            data-testid="BgEvents.Empty.Label"
          >
            {t('LocationHours.temporaryHours.standardHours.emptyLabel')}
          </Typography>
        ) : (
          groupedBackgroundEvents.map(event => (
            <Box key={event.day}>
              <Typography key={event.day} variant="body1">
                {event.day}:
              </Typography>
              {event.pickup && event.pickup.length > 0 && (
                <StandardHoursListItem
                  orderTypeWithTimeSlots={t(
                    'LocationHours.temporaryHours.standardHours.orderTypeOptions.pickup',
                    {
                      timeSlots: event.pickup.join(', '),
                    },
                  )}
                  color={blue[500]}
                />
              )}
              {event.delivery && event.delivery.length > 0 && (
                <StandardHoursListItem
                  orderTypeWithTimeSlots={t(
                    'LocationHours.temporaryHours.standardHours.orderTypeOptions.delivery',
                    {
                      timeSlots: event.delivery.join(', '),
                    },
                  )}
                  color={green[500]}
                />
              )}
            </Box>
          ))
        )}
      </Stack>
    </Paper>
  );
};

export default StandardHoursList;
